<template>

<div class="row"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->

    <div class="content d-flex flex-column flex-column-fluid">
        <!-- Adaugă Factură Card -->
        <div class="container-fluid mb-12">
          <div class="card card-flush">
            <div class="card-header d-flex align-items-center justify-content-between">
              <h3 class="card-title mb-0">Adaugă Factură</h3>
              <button type="button" class="btn btn-sm btn-light-primary" @click="deschideModalFP">
                Preia din FP
              </button>
            </div>
            <div class="card-body pt-0">
              <!-- Fallback visual confirmation for mounting -->
              <form onsubmit="return false;" id="formular_rapid" @keydown="handleFullArrowNavigation">
                <div class="table-responsive">
                  <div class="row g-3 flex-wrap">
                    <div class="col-md-auto col-6">
                      <label class="form-label">Seria si nr. document</label>
                      <div class="input-group">
                        <input
                          id="id_serie"
                          v-model="factura.serie_document"
                          type="text"
                          class="form-control w-50"
                          placeholder="Serie"
                        />
                        <input v-model="factura.nr_document" type="text" class="form-control" placeholder="Nr.">
                      </div>
                    </div>
                    <!-- Furnizor -->
                    <div class="col-md-auto col-12">
                      <label class="form-label">Furnizor</label>
                      <div class="d-flex flex-wrap align-items-center gap-2">
                        <div style="flex-grow: 1; min-width: 200px; max-width: 400px;">
                          <multiselect
                            id="id_furnizor"
                            v-model="factura.furnizor_obj"
                            :options="lista_furnizori"
                            :custom-label="option => option.text"
                            track-by="id"
                            placeholder="Furnizor"
                            class="form-control furnizor-multiselect"
                            :open-direction="'bottom'"
                            :select-label="''"
                            :deselect-label="''"
                            :selected-label="''"
                            @update:modelValue="val => {
                              factura.furnizor = val?.id || '';
                              factura.furnizor_obj = val || null;
                              incarcaSoldFurnizorSelected(val);
                            }"
                          >
                            <!-- Mesaj custom când nu există rezultate -->
                            <template #noResult="{ search }">
                              <div class="text-center p-2">
                                <div class="text-muted mb-2">
                                  Furnizorul "<strong>{{ search }}</strong>" nu există.
                                </div>
                                <button
                                  type="button"
                                  class="btn btn-sm btn-primary"
                                  @click="deschideFormAdaugareFurnizor(search)"
                                >
                                  Adaugă furnizor
                                </button>
                              </div>
                            </template>
                          </multiselect>
                        </div>
                        <button class="btn btn-sm btn-light" type="button" @click="modalNomenclatorFurnizori">
                          <i class="fas fa-list"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-auto col-6">
                      <label class="form-label">Data emitere</label>
                      <input v-model="factura.data_emitere" type="date" class="form-control" />
                    </div>
                    <div class="col-md-auto col-6">
                      <label class="form-label">Termen plata</label>
                      <input v-model="factura.termen_plata" type="date" class="form-control" />
                    </div>
                    <div class="col-md-auto col-6">
                      <label class="form-label">Sold</label>
                      <input :value="$filters.toCurrency(factura.sold)" type="text" class="form-control" disabled />
                    </div>
                    <div class="col-md-auto col-6">
                      <label class="form-label">e-Factura</label>
                      <select v-model="factura.efactura" class="form-select">
                        <option value="Neplătită">Neplătită</option>
                        <option value="Plătită">Plătită</option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- Responsive produse/servicii -->
                <div class="table-responsive mt-5">
                  <div class="d-none d-md-block">
                    <!-- Header mimic on desktop -->
                    <div class="row fw-bold border-bottom pb-2 mb-2">
                      <div class="col" style="width: 50px; max-width: 50px; min-width: 50px;">#</div>
                      <div class="col" style="min-width: 100px;">Tip</div>
                      <div class="col" style="min-width: 280px; max-width: 280px; width: 280px;">Denumire articol / serviciu</div>
                      <div class="col" style="min-width: 100px; max-width: 100px; width: 100px;">UM</div>
                      <div class="col" style="width: 80px; max-width: 80px; min-width: 80px;">TVA%</div>
                      <div class="col" style="width: 120px; max-width: 120px; min-width: 120px;">Cantitate</div>
                      <div class="col" style="min-width: 130px;">Preț unitar</div>
                      <div class="col" style="min-width: 130px;">Valoare</div>
                      <div class="col" style="min-width: 130px;">TVA</div>
                      <div class="col" style="min-width: 130px;">Total</div>
                      <div class="col" style="min-width: 100px;">Cont credit</div>
                    </div>
                  </div>
                  <draggable v-model="facturaProduse" handle=".handle" item-key="pozitie" :clone="item => ({ ...item })">
                    <template #item="{ element: produs, index }"> 
                      <div class="row g-2 gx-1 align-items-center mb-3" :key="index">
                        <!-- Pozitie (drag handle) -->
                        <div style="width: 50px; max-width: 50px; min-width: 50px;">
                          <label class="d-md-none form-label">Pozitie</label>
                          <div class="handle" style="cursor: move;">
                            {{ index + 1 }}
                          </div>
                        </div>
                        <!-- Tip -->
                        <div class="col tip-col" style="min-width: 100px;">
                          <label class="d-md-none form-label">Tip</label>
                          <multiselect
                            :id="'tip_produse-' + produs.pozitie"
                            v-model="produs.tip_obj"
                            :options="tip_produse"
                            :custom-label="option => option.text"
                            track-by="id"
                            placeholder="Tip produs"
                            class="form-control tip-produse-multiselect"
                            :open-direction="'bottom'"
                            :select-label="''"
                            :deselect-label="''"
                            :selected-label="''"
                            :allow-empty="false"
                            :show-clear="false"
                            @update:modelValue="val => { produs.tip = val?.id }"
                          >
                            <template #singleLabel="{ option }">
                              <span :title="option?.text || ''">{{ option?.text || '' }}</span>
                            </template>
                          </multiselect>
                          
                        </div>
                        <!-- Denumire articol / serviciu -->
                        <div class="col-auto text-truncate overflow-hidden denumire-col" style="min-width: 280px; max-width: 280px; width: 280px;">
                          <label class="form-label d-md-none">Denumire</label>
                          <div class="d-flex align-items-center gap-2 w-100">
                              <multiselect v-if="produs.tip == 1"
                                :id="'produs-' + produs.pozitie"
                                v-model="produs.denumire_obj"
                                :options="lista_produse"
                                :custom-label="option => option.text"
                                :taggable="true"
                                :allow-empty="false"
                                :open-direction="'bottom'"
                                placeholder="Denumire"
                                @tag="newTag => {
                                  const newOption = { id: null, text: newTag };
                                  lista_produse.push(newOption);
                                  produs.denumire_obj = newOption;
                                  produs.denumire = newOption.text;
                                  adaugaRandProdusDacaETGol();
                                }"
                                @update:modelValue="val => {
                                  produs.denumire = val?.text || '';
                                  produs.denumire_obj = val;
                                  adaugaRandProdusDacaETGol();
                                }"
                                class="form-control multiselect-custom"
                              >
                                <template #singleLabel="{ option }">
                                  <span :title="option?.text || ''">{{ option?.text || '' }}</span>
                                </template>
                              </multiselect>
                            <template v-if="produs.tip == 2">
                              <multiselect v-if="produs.tip == 2"
                                :id="'produs-' + produs.pozitie"
                                v-model="produs.denumire_obj"
                                :options="lista_produse_stoc"
                                :custom-label="option => option.text"
                                :allow-empty="false"
                                :open-direction="'bottom'"
                                placeholder="Denumire"
                                @update:modelValue="val => {
                                  produs.denumire = val?.text || '';
                                  produs.denumire_obj = val;
                                  adaugaRandProdusDacaETGol();
                                }"
                                class="form-control multiselect-denumire"
                              >
                                <template #singleLabel="{ option }">
                                  <span :title="option?.text || ''">{{ option?.text || '' }}</span>
                                </template>
                              </multiselect>
                              <button
                                class="btn btn-sm btn-icon btn-light-primary"
                                @click="deschideNomenclatorProduseStoc()">
                                <i class="fas fa-list"></i>
                              </button>
                            </template>
                          </div>
                        </div>
                        <!-- UM -->
                        <div class="col" style="min-width: 120px; max-width: 120px; width: 120px;">
                          <label class="d-md-none form-label">UM</label>
                          <multiselect
                            :modelValue="getUmObject(produs.um)"
                            @update:modelValue="val => produs.um = val.id"
                            :options="unitati_masura"
                            label="text"
                            track-by="id"
                            placeholder="UM"
                            :select-label="''"
                            :deselect-label="''"
                            class="multiselect-custom"
                            style="width: 120px;"
                            :open-direction="'bottom'"
                          >
                            <template #singleLabel="{ option }">
                              {{ option.text.split(' (')[0] }}
                            </template>
                          </multiselect>
                        </div>
                        <div class="col" style="width: 80px; max-width: 80px; min-width: 80px;">
                          <label class="d-md-none form-label">TVA %</label>
                          <input type="number" v-model.number="produs.cota_tva" @input="updateCalculations(produs)" class="form-control" placeholder="TVA %" style="width: 80px; max-width: 80px; min-width: 80px;" />
                        </div>
                        <!-- Cantitate -->
                        <div class="col" style="width: 120px; max-width: 120px; min-width: 120px;">
                          <label class="d-md-none form-label">Cantitate</label>
                          <input v-model="produs.cantitate" @input="updateCalcul(index, 'cantitate')" type="number" class="form-control" placeholder="Cantitate" />
                        </div>
                        <!-- Pret unitar -->
                        <div class="col" style="min-width: 130px;">
                          <label class="d-md-none form-label">Preț unitar</label>
                          <input v-model="produs.pret" @input="updateCalcul(index, 'pret')" type="number" class="form-control" placeholder="Preț unitar" />
                        </div>
                        <!-- Valoare -->
                        <div class="col" style="min-width: 130px;">
                          <label class="d-md-none form-label">Valoare</label>
                          <input v-model="produs.valoare" @input="updateCalcul(index, 'valoare')" type="text" class="form-control" placeholder="Valoare" />
                        </div>
                        <!-- TVA -->
                        <div class="col" style="min-width: 130px;">
                          <label class="d-md-none form-label">TVA</label>
                          <input type="text" :value="produs.valoare_tva" @input="updateCalculations(produs)" class="form-control" placeholder="TVA" readonly />
                        </div>
                        <!-- Total -->
                        <div class="col" style="min-width: 130px;">
                          <label class="d-md-none form-label">Total</label>
                          <input type="text" v-model="produs.total" @input="updateFromTotal(index)" class="form-control" placeholder="Total" />
                        </div>
                        <!-- Cont credit -->
                        <div class="col" style="min-width: 100px;">
                          <label class="d-md-none form-label">Cont credit</label>
                          <input v-model="produs.cont_credit" type="text" class="form-control" />
                        </div>
                      </div>
                    </template>
                  </draggable>
                </div>
              </form>
              <!-- Toggle button for extra info sections and Adaugă/Renunță buttons, all on one row -->
              <div class="mt-10 d-flex align-items-center flex-wrap gap-3">
                <button class="btn btn-secondary" type="button" @click="afiseazaInformatii = !afiseazaInformatii" >
                  {{ afiseazaInformatii ? 'Ascunde mai multe informații' : 'Afișează mai multe informații' }}
                </button>
                <div class="d-flex gap-3 ms-auto">
                  <button type="button" class="btn btn-light" @click="$emit('renuntaFactura')">Renunță</button>
                  <button type="button" class="btn btn-primary" @click="adaugaFactura()">Adaugă</button>
                </div>
              </div>
              <!-- Extra info sections, shown only if afiseazaInformatii -->
              <div v-if="afiseazaInformatii">
                <div class="mt-10">
                  <div class="row">
                    <!-- Stânga: Informații suplimentare (textbox) -->
                    <div class="col-md-6">
                      <h4 class="mb-3">Informații suplimentare</h4>
                      <textarea
                        v-model="factura.informatii_suplimentare"
                        class="form-control"
                        rows="5"
                        placeholder="Adaugă informații adiționale aici..."
                      ></textarea>
                    </div>
                    <!-- Dreapta: Descarcarea de gestiune (radio) -->
                    <div class="col-md-6">
                      <h4 class="mb-3">Descarcarea de gestiune</h4>
                      <div class="form-check mb-2">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="informatie_suplimentara"
                          id="opt1"
                          value="1"
                          v-model="factura.descarcare_gestiune"
                          checked
                        />
                        <label class="form-check-label" for="opt1">
                          Descarcarea de gestiune se face la salvarea acestui document. <br />
                          Livrarea produselor se face în baza acestui document.
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="informatie_suplimentara"
                          id="opt2"
                          value="2"
                          v-model="factura.descarcare_gestiune"
                        />
                        <label class="form-check-label" for="opt2">
                          Descarcarea de gestiune se face pe baza Avizului de Însoțire. <br />
                          Livrarea produselor se face pe baza Avizului de Însoțire a Mărfurilor.
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- New row of fields below Descarcarea de gestiune -->
                <div class="mt-10">
                  <div class="row">
                    <div class="col-md-2 mb-3">
                      <label class="form-label">Delegat</label>
                      <input v-model="factura.delegat_nume" type="text" class="form-control" />
                    </div>
                    <div class="col-md-2 mb-3">
                      <label class="form-label">CNP/Buletin delegat</label>
                      <input v-model="factura.delegat_date" type="text" class="form-control" />
                    </div>
                    <div class="col-md-2 mb-3">
                      <label class="form-label">Auto</label>
                      <input v-model="factura.delegat_auto" type="text" class="form-control" />
                    </div>
                    <div class="col-md-2 mb-3">
                      <label class="form-label">Curs Valutar</label>
                      <div class="input-group">
                        <Select2
                          id="valuta"
                          v-model="factura.valuta"
                          :options="valute"
                          :settings="setari_select2"
                          @select="onSelectValuta"
                        />
                        <input
                          v-model="factura.curs_valutar"
                          type="number"
                          step="0.0001"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-md-2 mb-3">
                      <label class="form-label">Întocmit de</label>
                      <input v-model="factura.intocmit_de" type="text" class="form-control" />
                    </div>
                    <div class="col-md-2 mb-3">
                      <label class="form-label">CNP</label>
                      <input v-model="factura.intocmit_cnp" type="text" class="form-control" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Metronic-styled switch to toggle Tabel Facturare -->
        <div class="container-fluid mb-6">
          <div class="form-check form-switch form-check-custom form-check-solid">
            <input class="form-check-input" type="checkbox" id="switch_afiseaza_lista" v-model="modelAfiseazaLista"/>
            <label class="form-check-label ms-3" for="switch_afiseaza_lista">
                Afișează Lista Facturi primite
            </label>
          </div>
        </div>
    </div>

</div>


    <!-- Modal furnizor -->
    <div class="modal fade" id="FurnizorModal" role="dialog" aria-labelledby="FurnizorModalLabel">
      <div class="modal-dialog" style="max-width: 95vw; margin: 1rem auto;">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="FurnizorModalLabel">Nomenclator Furnizori</h3>
            <!--begin::Close-->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            <!--end::Close-->
          </div>
          <div class="modal-body">
            <div v-if="showFormAdaugareFurnizor" class="p-4 border-bottom">
              <div class="row g-3">
                <!-- Row 1 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Denumire</label>
                    <input v-model="form_modal_furnizori.f_denumire" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numele complet al furnizorului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">CUI</label>
                    <div class="input-group">
                      <input
                        v-model="form_modal_furnizori.c_cui"
                        type="text"
                        class="form-control"
                        placeholder="Introduceți CUI"
                      />
                      <button
                        class="btn btn-sm btn-icon btn-light-primary"
                        type="button"
                        @click="verificaCUI(form_modal_furnizori.c_cui)"
                      >
                        <i class="fas fa-search"></i>
                      </button>
                    </div>
                    <div class="text-muted fs-7">Codul unic de identificare fiscală.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Reg. Com.</label>
                    <input v-model="form_modal_furnizori.c_reg_com" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numărul de înregistrare la registrul comerțului.</div>
                  </div>
                </div>
                <!-- Row 2 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Localitate</label>
                    <input v-model="form_modal_furnizori.c_localitate" type="text" class="form-control" />
                    <div class="text-muted fs-7">Localitatea sediului furnizorului. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Telefon</label>
                    <input v-model="form_modal_furnizori.c_telefon" type="text" class="form-control" />
                    <div class="text-muted fs-7">Număr de contact al furnizorului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Email</label>
                    <input v-model="form_modal_furnizori.c_email" type="email" class="form-control" />
                    <div class="text-muted fs-7">Adresă de email validă pentru contact.</div>
                  </div>
                </div>
                <!-- Strada -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Strada</label>
                    <input v-model="form_modal_furnizori.c_strada" type="text" class="form-control" />
                    <div class="text-muted fs-7">Strada sediului furnizorului. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <!-- Cod poștal -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Cod poștal</label>
                    <input v-model="form_modal_furnizori.c_cod_postal" type="text" class="form-control" />
                    <div class="text-muted fs-7">Codul poștal al sediului. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <!-- Row 3 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Adresă</label>
                    <input v-model="form_modal_furnizori.c_adresa" type="text" class="form-control" />
                    <div class="text-muted fs-7">Adresă completă a sediului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Județ</label>
                    <input v-model="form_modal_furnizori.c_judet" type="text" class="form-control" />
                    <div class="text-muted fs-7">Județul în care se află furnizorul. <span class="text-danger">* (necesar e-Factura)</span></div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Țara</label>
                    <input v-model="form_modal_furnizori.c_tara" type="text" class="form-control" />
                    <div class="text-muted fs-7">Țara de rezidență a furnizorului.</div>
                  </div>
                </div>
                <!-- Row 4 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Banca</label>
                    <input v-model="form_modal_furnizori.c_banca" type="text" class="form-control" />
                    <div class="text-muted fs-7">Instituția bancară a furnizorului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Cont bancar</label>
                    <input v-model="form_modal_furnizori.c_cont_banca" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numărul contului bancar.</div>
                  </div>
                </div>
                <!-- Row 5 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Persoană de contact</label>
                    <input v-model="form_modal_furnizori.c_pers_contact" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numele persoanei de contact.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Delegat</label>
                    <input v-model="form_modal_furnizori.c_delegat" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numele delegatului care livrează produsele.</div>
                  </div>
                </div>
                <!-- Row 6 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">CNP Delegat</label>
                    <input v-model="form_modal_furnizori.c_delegat_cnp" type="text" class="form-control" />
                    <div class="text-muted fs-7">Cod numeric personal al delegatului.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Serie CI</label>
                    <input v-model="form_modal_furnizori.c_ci_serie" type="text" class="form-control" />
                    <div class="text-muted fs-7">Serie carte de identitate.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Număr CI</label>
                    <input v-model="form_modal_furnizori.c_ci_nr" type="text" class="form-control" />
                    <div class="text-muted fs-7">Număr carte de identitate.</div>
                  </div>
                </div>
                <!-- Row 7 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">CI eliberat de</label>
                    <input v-model="form_modal_furnizori.c_ci_eliberat" type="text" class="form-control" />
                    <div class="text-muted fs-7">Instituția care a eliberat CI-ul.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Auto delegat</label>
                    <input v-model="form_modal_furnizori.c_delegat_auto" type="text" class="form-control" />
                    <div class="text-muted fs-7">Autovehicul folosit de delegat.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Cod agent</label>
                    <input v-model="form_modal_furnizori.c_cod_agent" type="text" class="form-control" />
                    <div class="text-muted fs-7">Cod intern al agentului.</div>
                  </div>
                </div>
                <!-- Row 8 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Zile scadență</label>
                    <input v-model="form_modal_furnizori.c_scadenta" type="text" class="form-control" />
                    <div class="text-muted fs-7">Numărul de zile până la scadență.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Discount</label>
                    <input v-model="form_modal_furnizori.c_discount" type="text" class="form-control" />
                    <div class="text-muted fs-7">Reducere acordată în %.</div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">Atrib. fiscal</label>
                    <input v-model="form_modal_furnizori.c_atrib_fiscal" type="text" class="form-control" />
                    <div class="text-muted fs-7">Atribuția fiscală a furnizorului.</div>
                  </div>
                </div>
                <!-- Row 9 -->
                <div class="col-md-2">
                  <div class="mb-1">
                    <label class="form-label">SCP TVA</label>
                    <input v-model="form_modal_furnizori.c_scp_tva" type="text" class="form-control" />
                    <div class="text-muted fs-7">Sistemul de plată al TVA-ului.</div>
                  </div>
                </div>
                <div class="col-12 text-end">
                  <button class="btn btn-sm btn-success" @click="adaugaFurnizor()" v-if="!editmode">Adaugă furnizorul</button>
                  <button class="btn btn-sm btn-success" @click="actualizeazaFurnizor(form_modal_furnizori.c_id)" v-if="editmode">Actualizează furnizorul</button>
                </div>
              </div>
            </div>
            <button class="btn btn-sm btn-primary" @click="showFormAdaugareFurnizor = !showFormAdaugareFurnizor">
              {{ showFormAdaugareFurnizor ? 'Anulează' : 'Adauga furnizor' }}
            </button>
            <table id="tabel_furnizori" class="table table-bordered table-striped table-hover align-middle">
              <thead class="table-light fw-bold">
                <tr>
                   <th class="min-w-30px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="ID Furnizor: apasa pentru sortare crescatoare">ID</th>
                   <th class="min-w-150px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Denumire: apasa pentru sortare crescatoare">Denumire</th>
                   <th class="min-w-50px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Cui: apasa pentru sortare crescatoare">CUI</th>
                   <th class="min-w-80px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Registru Comertului: apasa pentru sortare crescatoare">Reg.Com</th>
                   <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Localitate: apasa pentru sortare crescatoare">Localitate</th>
                   <th class="min-w-100px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Zile scadenta: apasa pentru sortare crescatoare">Zile scadenta</th>
                   <th class="min-w-80px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Reducere acordata: apasa pentru sortare crescatoare">Reducere acordata</th>
                   <th class="min-w-70px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Email: apasa pentru sortare crescatoare">Email</th>
                   <th class="min-w-100px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Telefon: apasa pentru sortare crescatoare">Telefon</th>
                   <th class="min-w-80px sorting" tabindex="0" aria-controls="tabel_furnizori" rowspan="1" colspan="1" aria-label="Persoana de contact: apasa pentru sortare crescatoare">Persoana de contact</th>
                   <th class="min-w-20px" tabindex="0" rowspan="1" colspan="1" aria-label="Actiuni">Actiuni</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dc in detalii_furnizori" :key="dc.id">
                  <td>{{ dc.c_id || '' }}</td>
                  <td>{{ dc.c_denumire || '' }}</td>
                  <td>{{ dc.c_cui || '' }}</td>
                  <td>{{ dc.c_reg_com || '' }}</td>
                  <td>{{ dc.c_localitate || '' }}</td>
                  <td>{{ dc.c_scadenta || '' }}</td>
                  <td>{{ dc.c_discount || '' }}</td>
                  <td>{{ dc.c_email || '' }}</td>
                  <td>{{ dc.c_telefon || '' }}</td>
                  <td>{{ dc.c_pers_contact || '' }}</td>
                  <td>
                    <div class="d-flex flex-column flex-md-row gap-2">
                      <button class="btn btn-sm btn-warning" @click="editareFurnizorFormFill(dc)">Modifică</button>
                      <button class="btn btn-sm btn-danger" @click="modalStergeFurnizor(form_modal_furnizori)">Șterge</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Închide</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Proforme (Preia din FP) -->
<div class="modal fade" id="ModalProforme" tabindex="-1" role="dialog" aria-labelledby="ModalProformeLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ModalProformeLabel">Proforme nefacturate</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th style="width: 80px;">ID</th>
                <th>Nr. doc</th>
                <th>Data</th>
                <th>Furnizor</th>
                <th class="text-end">Total</th>
                <th style="width: 120px;">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="proforme.length === 0">
                <td colspan="6" class="text-center text-muted py-5">Nu există proforme disponibile.</td>
              </tr>
              <tr v-for="pf in proforme" :key="pf.id">
                <td>{{ pf.id }}</td>
                <td>{{ pf.nr_doc }}</td>
                <td>{{ pf.data_doc }}</td>
                <td>{{ pf.furnizor_denumire }}</td>
                <td class="text-end">{{ $filters.toCurrency(pf.total) }}</td>
                <td class="d-flex gap-2 actions">
                  <!-- Buton Precompletare -->
                  <button type="button" class="btn btn-sm btn-light-primary flex-fill" :disabled="pf._loading" @click="selecteazaProforma(pf)">
                    <span v-if="pf._loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span>{{ pf._loading ? 'Se încarcă…' : 'Select' }}</span>
                  </button>

                  <!-- Buton Creează instant -->
                  <button type="button" class="btn btn-sm btn-success flex-fill" :disabled="pf._creating" @click="creeazaFacturaInstant(pf)">
                    <span v-if="pf._creating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    <span>{{ pf._creating ? 'Se creează…' : 'Creează acum' }}</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Închide</button>
      </div>
    </div>
  </div>
</div>
</template>


<script>
    
    import moment from "moment";
    import draggable from 'vuedraggable';
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'
    
    
    export default {
        props: {
            afiseazaLista: Boolean
        },
        emits: ['update:afiseazaLista', 'renuntaFactura'],
        components: {
            moment: moment,
            draggable,
            Multiselect,
        },
    data () {
      return {
        setari_select2: {
            theme: 'bootstrap-5',
            placeholder: "Selectează din listă",
            width: "100%",
        },
        setari_select2_produse: {
            theme: 'bootstrap-5',
            tags: true,
            width: "100%",
        },
        setari_select2_serie: {
            theme: 'bootstrap-5',
            placeholder: "Seria",
            width: "100%",
        },
        setari_select2_um: {
            theme: 'bootstrap-5',
            placeholder: "Selectează din listă",
            width: "100%",
        },
        furnizori: [],
        lista_furnizori: [],
        detalii_furnizori: [],
        serii_facturi: [],
        // Asigură-te că unitati_masura este definit ca ref (folosim Vue 2, deci data property, dar pentru <script setup> ar fi ref)
        unitati_masura: [],
        tip_produse: [],
        lista_produse: [],
        lista_produse_stoc: [],
        valute: [],
        editmode: false,
        facturi_emise: [],
        afiseazaInformatii: false,
        factura: Form.make({
            id: '',
            // pentru facturi de intrare lucrăm logic cu furnizor
            furnizor: '',
            furnizor_obj: '',
            serie_document: '',
            serie_document_obj: '',
            nr_document: '',
            data_emitere: new Date().toISOString().split('T')[0],
            termen_plata: new Date().toISOString().split('T')[0],
            sold: '',
            efactura: 'Neplătită',
            descarcare_gestiune: '1', // salvare(1) / aviz(2) 
            informatii_suplimentare: '', // nou
            delegat_nume: '',
            delegat_date: '',
            delegat_auto: '',
            valuta: 1,
            curs_valutar: '',
            intocmit_de: '',
            intocmit_cnp: '',
        }),
        showFormAdaugareFurnizor: false,
        form_modal_furnizori: Form.make({
            c_id: '',
            c_cut: '',
            f_denumire: '',
            c_cui: '',
            c_reg_com: '',
            c_localitate: '',
            c_strada: '',
            c_cod_postal: '',
            c_adresa: '',
            c_judet: '',
            c_tara: '',
            c_banca: '',
            c_cont_banca: '',
            c_email: '',
            c_telefon: '',
            c_pers_contact: '',
            c_delegat: '',
            c_delegat_cnp: '',
            c_ci_serie: '',
            c_ci_nr: '',
            c_ci_eliberat: '',
            c_delegat_auto: '',
            c_cod_agent: '',
            c_scadenta: '',
            c_discount: '',
            c_atrib_fiscal: '',
            c_scp_tva: '',
        }),
        facturaProduse: [
          {
            pozitie: 1,
            tip: '1',
            tip_obj: '',
            denumire: '',
            denumire_obj: '',
            um: '',
            cota_tva: 19,
            cantitate: '',
            pret: '',
            valoare: '',
            valoare_tva: '',
            total: '',
            cont_credit: ''
          }
        ],
        proforme: [],
        id_proforma_selectata: null,
      }
    },

    methods: {
      
        async verificaCUI(cui) 
        {

          if (!cui) {
            this.$bvToast.toast('Introdu un CUI valid.', {
              title: 'Eroare',
              variant: 'danger',
              solid: true,
            });
            return;
          }

          try {
            const response = await axios.post('/api/efactura/verifica-cui/furnizor', { cui });

            const data = response.data;

            //if (data.status === 'exists') {
            //  this.$bvToast.toast('Furnizorul există deja în baza de date.', {
            //    title: 'Informație',
            //    variant: 'warning',
            //    solid: true,
            //  });
            //  return;
            //}

            if (response.data.status === 'exists' || response.data.status === 'preview') {
              const furnizor = response.data.client;

              // Autocomplete form
              this.form_modal_furnizori.f_denumire = furnizor.denumire || '';
              this.form_modal_furnizori.c_cui = furnizor.cui || '';
              this.form_modal_furnizori.c_reg_com = furnizor.reg_com || '';
              this.form_modal_furnizori.c_atrib_fiscal = furnizor.atrib_fiscal || '';
              this.form_modal_furnizori.c_scp_tva = furnizor.scp_tva || '';
              this.form_modal_furnizori.c_localitate = furnizor.localitate || '';
              this.form_modal_furnizori.c_strada = furnizor.strada || '';
              this.form_modal_furnizori.c_cod_postal = furnizor.cod_postal || '';
              this.form_modal_furnizori.c_adresa = furnizor.adresa || '';
              this.form_modal_furnizori.c_judet = furnizor.judet || '';
              this.form_modal_furnizori.c_tara = furnizor.tara || '';
              this.form_modal_furnizori.c_cont_banca = furnizor.cont_banca || '';
              this.form_modal_furnizori.c_telefon = furnizor.telefon || '';
              this.form_modal_furnizori.c_cut = furnizor.cut || '';

              toast.fire({
                    icon: 'success',
                    //title: 'Date preluate cu succes din ANAF.',
                    title: response.data.message || 'Furnizorul a fost găsit.',
              });
            } else {
              toast.fire({
                    icon: 'warning',
                    title: 'CUI-ul nu a fost găsit în ANAF.',
              });
            }
          } catch (error) {
            console.error(error);
            toast.fire({
                    icon: 'warning',
                    title: 'Eroare la verificarea CUI.'
            });
          }
        },
        adaugaProdusNou(newTag) {
          const newOption = { id: null, text: newTag };
          this.lista_produse.push(newOption);
          return newOption;
        },
        getUmObject(id) {
            // Dacă unitati_masura e ref, folosește .value, altfel direct (aici e array simplu)
            return this.unitati_masura.find(um => um.id === id) || null;
        },
        adaugaRandProdusDacaETGol() {
            // Add a new row if EITHER 'tip' OR 'denumire' from last row is filled, and only one empty row at the end is allowed.
            const produse = this.facturaProduse;
            if (produse.length === 0) return;

            // Helper: a row is empty if all fields except 'pozitie' are blank/null/undefined
            function isRowEmpty(row) {
                return Object.entries(row).every(([key, val]) =>
                    key === 'pozitie' || val === '' || val === null || val === undefined
                );
            }

            // Count how many empty rows are at the end
            let emptyRowsAtEnd = 0;
            for (let i = produse.length - 1; i >= 0; i--) {
                if (isRowEmpty(produse[i])) {
                    emptyRowsAtEnd++;
                } else {
                    break;
                }
            }

            // Get last row
            const last = produse[produse.length - 1];
            // If EITHER 'tip' OR 'denumire' is filled in last row and no empty row at end, add one
            if (
                (
                    (last.tip && last.tip !== '') ||
                    (last.denumire && last.denumire !== '')
                ) &&
                emptyRowsAtEnd === 0
            ) {
                this.facturaProduse.push({
                    pozitie: produse.length + 1,
                    tip: '1',
                    tip_obj: this.tip_produse.find(t => t.id === 1),
                    denumire: '',
                    um: '',
                    cota_tva: 19,
                    cantitate: '',
                    pret: '',
                    valoare: '',
                    valoare_tva: '',
                    total: '',
                    cont_credit: ''
                });
                emptyRowsAtEnd = 1; // just added one
            }

            // Keep only one empty row at end (if more, remove extras)
            if (emptyRowsAtEnd > 1) {
                this.facturaProduse.splice(-1, emptyRowsAtEnd - 1);
            }
        },
        incarcaProduseSelect2(){
            axios.get('/api/facturare/utils/incarcaProduse')
            .then((response) => {
                this.lista_produse = response.data;
            });
        },
        onSelectValuta(valutaId) {
          const id = typeof valutaId === 'object' ? valutaId.id : valutaId;
          if (id && id !== '1') {
            this.incarcaValoareCursValutar(id);
          } else {
            this.factura.curs_valutar = 1;
          }
        },
        incarcaValute(){
            axios.get('/api/facturare/utils/iaValute')
            .then((response) => {
                this.valute = response.data;
            });
        },
        incarcaValoareCursValutar(id){
            axios.get('/api/facturare/utils/iaValute/'+id)
            .then((response) => {
                this.factura.curs_valutar = response.data;
            });
        },
        deschideNomenclatorProduseStoc() {
          // aici poți face ce vrei când se apasă pe buton
          console.log('Buton activat pentru:', );
        },
        async onSerieSelected(selected) {
          //console.log(selected.id)
          this.factura.serie_document = selected?.id;
          const serie = selected.id || selected.text || selected;
          try {
            const response = await axios.get(`/api/facturare/utils/incarcaNrFactura/${serie}`);
            const ultimNr = parseInt(response.data);
            this.factura.nr_document = ultimNr + 1;
          } catch (error) {
            console.error('Eroare la preluarea numărului document:', error);
          }
        },
        async incarcaSoldFurnizorSelected(selected) {
          const furnizor = selected.id || selected.text || selected;
          try {
            const response = await axios.get(`/api/facturare/utils/incarcaSoldFurnizor/${furnizor}`);
            this.factura.sold = response.data;
          } catch (error) {
            console.error('Eroare la incarcarea soldului firmei', error);
          }
        },
        reindexPozitii() {
          this.facturaProduse.forEach((p, i) => {
            p.pozitie = i + 1;
          });
        },
        updateCalcul(index, triggeredBy) {
          const p = this.facturaProduse[index];
          const qty = parseFloat(p.cantitate) || 0;
          const price = parseFloat(p.pret) || 0;
          const value = parseFloat(p.valoare) || 0;
          const tvaPercent = parseFloat(p.cota_tva) || 0;

          if (triggeredBy === 'cantitate' || triggeredBy === 'pret') {
            const newVal = qty * price;
            p.valoare = newVal.toFixed(2);
            p.valoare_tva = (newVal * tvaPercent / 100).toFixed(2);
            p.total = (newVal + (newVal * tvaPercent / 100)).toFixed(2);
          }

          if (triggeredBy === 'valoare') {
            const newPrice = qty > 0 ? value / qty : 0;
            p.pret = newPrice.toFixed(2);
            p.valoare_tva = (value * tvaPercent / 100).toFixed(2);
            p.total = (value + (value * tvaPercent / 100)).toFixed(2);
          }
        },
        updateFromTotal(index) {
          // Adaugat: recalculare cand totalul este modificat direct
          const produs = this.facturaProduse[index];

          const total = parseFloat(produs.total) || 0;
          const cantitate = parseFloat(produs.cantitate) || 1;
          const cota_tva = parseFloat(produs.cota_tva) || 0;

          const valoare_tva = total * (cota_tva / (100 + cota_tva));
          const valoare = total - valoare_tva;
          const pret = cantitate !== 0 ? valoare / cantitate : 0;

          produs.valoare = valoare.toFixed(2);
          produs.valoare_tva = valoare_tva.toFixed(2);
          produs.pret = pret.toFixed(2);
        },
        updateCalculProdus(index) {
          // Actualizare la modificarea oricarui camp relevant pentru produs (inclusiv total)
          const produs = this.facturaProduse[index];

          const cantitate = parseFloat(produs.cantitate) || 0;
          const pret = parseFloat(produs.pret) || 0;
          const cota_tva = parseFloat(produs.cota_tva) || 0;
          const valoare = cantitate * pret;
          const valoare_tva = valoare * (cota_tva / 100);
          const total = valoare + valoare_tva;

          produs.valoare = valoare.toFixed(2);
          produs.valoare_tva = valoare_tva.toFixed(2);
          produs.total = total.toFixed(2);
        },
        incarcaUnitatiMasura(){
            axios.get('/api/facturare/utils/incarcaUnitatiMasura')
            .then((response) => {
                this.unitati_masura = response.data;
            });
        },
        incarcaTipProduse(){
            axios.get('/api/facturare/utils/incarcaTipProduse')
            .then((response) => {
                this.tip_produse = response.data;
                this.facturaProduse.forEach(produs => {
                  produs.tip_obj = this.tip_produse.find(t => t.id === Number(produs.tip)) || null;
                });
            });

        },
        handleFullArrowNavigation(event) {
            const selectors = '#formular input, #formular select, #formular textarea, #formular_rapid input, #formular_rapid select, #formular_rapid textarea';
            const inputs = Array.from(document.querySelectorAll(selectors)).filter(
                el => !el.disabled && el.offsetParent !== null
            );

            const index = inputs.indexOf(event.target);
            if (index === -1) return;

            // Detect .row-based layout for responsive facturaProduse
            const rowEl = event.target.closest('.row');
            let currentRowIndex = -1;
            let currentColIndex = -1;
            let rows = [];
            let usingRowLayout = false;

            if (rowEl) {
                // Find all sibling .row elements inside the same parent (the responsive container)
                rows = Array.from(rowEl.parentElement.querySelectorAll('.row')).filter(
                    row => row.querySelector('input, select, textarea')
                );
                for (let i = 0; i < rows.length; i++) {
                    const cols = Array.from(rows[i].querySelectorAll('input, select, textarea')).filter(
                        el => !el.disabled && el.offsetParent !== null
                    );
                    const colIndex = cols.indexOf(event.target);
                    if (colIndex !== -1) {
                        currentRowIndex = i;
                        currentColIndex = colIndex;
                        usingRowLayout = true;
                        break;
                    }
                }
            }

            // Fallback to table-based navigation if not in .row
            let table = null;
            let tableRows = [];
            let tableRowIdx = -1;
            let tableColIdx = -1;
            if (!usingRowLayout) {
                table = event.target.closest('table');
                if (table) {
                    tableRows = Array.from(table.querySelectorAll('tbody tr'));
                    for (let i = 0; i < tableRows.length; i++) {
                        const cols = Array.from(tableRows[i].querySelectorAll('input, select, textarea')).filter(
                            el => !el.disabled && el.offsetParent !== null
                        );
                        const colIndex = cols.indexOf(event.target);
                        if (colIndex !== -1) {
                            tableRowIdx = i;
                            tableColIdx = colIndex;
                            break;
                        }
                    }
                }
            }

            let next = null;
            const isNumberInput = event.target.tagName === 'INPUT' && event.target.type === 'number';
            switch (event.key) {
                case 'ArrowRight':
                    // Always move horizontally regardless of layout, even for number input
                    next = inputs[index + 1];
                    break;
                case 'ArrowLeft':
                    // Always move horizontally regardless of layout, even for number input
                    next = inputs[index - 1];
                    break;
                case 'ArrowDown':
                case 'ArrowUp':
                    if (isNumberInput) {
                        event.preventDefault();
                    }
                    // Responsive .row layout navigation
                    if (usingRowLayout && currentRowIndex !== -1 && currentColIndex !== -1) {
                        if (event.key === 'ArrowDown' && currentRowIndex < rows.length - 1) {
                            const nextRowInputs = Array.from(rows[currentRowIndex + 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = nextRowInputs[currentColIndex] || null;
                        }
                        if (event.key === 'ArrowUp' && currentRowIndex > 0) {
                            const prevRowInputs = Array.from(rows[currentRowIndex - 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = prevRowInputs[currentColIndex] || null;
                        }
                    }
                    // Table navigation fallback
                    if (!usingRowLayout && table && tableRowIdx !== -1 && tableColIdx !== -1) {
                        if (event.key === 'ArrowDown' && tableRowIdx < tableRows.length - 1) {
                            const nextRowInputs = Array.from(tableRows[tableRowIdx + 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = nextRowInputs[tableColIdx] || null;
                        }
                        if (event.key === 'ArrowUp' && tableRowIdx > 0) {
                            const prevRowInputs = Array.from(tableRows[tableRowIdx - 1].querySelectorAll('input, select, textarea')).filter(
                                el => !el.disabled && el.offsetParent !== null
                            );
                            next = prevRowInputs[tableColIdx] || null;
                        }
                    }
                    break;
            }

            if (next) {
                event.preventDefault();
                next.focus();
            }
        },
        incarcaFurnizori(){
            axios.get('/api/facturare/utils/incarcaFurnizori')
            .then((response) => {
                this.lista_furnizori = response.data;
            });
        },
        incarcaDetaliiFurnizori(){
            axios.get("/api/facturare/utils/furnizori")
            .then((response) => {
                this.detalii_furnizori = response.data;
                $(document).ready( function () {
                    $('#tabel_furnizori').DataTable().destroy();
                    $('#tabel_furnizori').DataTable({
                        order: [[0, 'desc']],
                        data: this.detalii_furnizori,
                        dom: 'Bfrtip',
                        buttons:['disable'],
                        language: {
                            url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                        },
                        paging: true,
                        ordering: true,
                        info: true,
                        searching: true,
                        responsive: true,
                        pageLength: 10,

                    });
                });
            });
        },
        adaugaFurnizor(){
            this.$Progress.start();
            this.form_modal_furnizori.post('/api/facturare/utils/furnizori')
            .then((response)=>{
                // MODIFICARE: verificare răspuns și setare id_furnizor + mesaje
                if (response.data && response.data.id) {
                  this.form.id_furnizor = response.data.id
                  this.furnizor.id = response.data.id
                  this.furnizor_deschis = false
                  toast.fire({
                    icon: 'success',
                    title: 'Furnizorul a fost adăugat și selectat cu succes.'
                  });
                }
                emitter.emit('AfterCreate');
                const id_nou = response.data.id;
                const nume_furnizor = this.form_modal_furnizori.f_denumire;

                // construim obiectul furnizor exact cum îl așteaptă multiselect-ul
                const furnizor_obj_nou = {
                  id: id_nou,
                  text: nume_furnizor
                };
                this.form_modal_furnizori.reset();
                this.showFormAdaugareFurnizor = false;
                $('#FurnizorModal').modal('hide');
                $('#tabel_furnizori').DataTable().destroy();
                this.incarcaFurnizori();
                
                this.factura.furnizor_obj = furnizor_obj_nou;
                this.factura.furnizor = furnizor_obj_nou.id;
                this.$Progress.finish();
            })
            .catch((error)=>{
                this.$Progress.fail()
                // Custom fallback logic: if backend returned an ID, treat as success
                if (error.response && error.response.data && error.response.data.id) {
                  this.form.id_furnizor = error.response.data.id
                  this.furnizor.id = error.response.data.id
                  this.furnizor_deschis = false
                  toast.fire({
                    icon: 'success',
                    title: 'Furnizorul a fost adăugat și selectat cu succes.'
                  });
                  // Optionally, you might want to close modal, reload furnizori, etc.
                  this.showFormAdaugareFurnizor = false;
                  $('#FurnizorModal').modal('hide');
                  this.incarcaFurnizori();
                  $('#tabel_furnizori').DataTable().destroy();
                  this.factura.furnizor = error.response.data.id;
                } else {
                  toast.fire({
                    icon: 'warning',
                    title: 'Eroare la adăugarea furnizorului!'
                  })
                }
            })
        },
        actualizeazaFurnizor(id){
            this.$Progress.start();
            this.form_modal_furnizori.put('/api/facturare/utils/furnizori/'+id)
            .then(()=>{ //succes
                //$('#FurnizorModal').modal('hide');
                toast.fire({
                    icon: 'success',
                    title: 'Furnizor actualizat!'
                })
                this.form_modal_furnizori.reset();
                this.showFormAdaugareFurnizor = false;
                this.incarcaFurnizori();
                $('#tabel_furnizori').DataTable().destroy();
                this.incarcaDetaliiFurnizori();
                this.$Progress.finish();
            })
            .catch(()=>{//fail
                this.$Progress.fail();
                toast.fire({
                    icon: 'warning',
                    title: 'Eroare la actualizarea furnizorului!'
                })
            });
        },
        updateCalculations(prod) {
            const cant = parseFloat(prod.cantitate) || 0;
            const pret = parseFloat(prod.pret) || 0;
            const tva = parseFloat(prod.cota_tva) || 0;
            prod.valoare = +(cant * pret).toFixed(2);
            prod.valoare_tva = +((prod.valoare * tva) / 100).toFixed(2);
            prod.total = +(prod.valoare + prod.valoare_tva).toFixed(2);
        },
        incarcaSerii(){
            axios.get('/api/facturare/utils/incarcaSerii')
            .then((response) => {
                this.serii_facturi = response.data;
            });
        },
        adaugaFactura() {
            this.$Progress.start();
            // Filtrare produse fără denumire
            const produseFiltrate = Array.isArray(this.facturaProduse)
              ? this.facturaProduse.filter(p => p.denumire && p.denumire.trim() !== '')
              : [];

            if (produseFiltrate.length === 0) {
              toast.fire({
                icon: 'error',
                title: 'Factura nu are niciun produs valid.'
              });
              this.$Progress.fail();
              return;
            }

            // asigură-te că pentru facturi de intrare avem furnizor setat
            if (!this.factura.furnizor && this.factura.furnizor) {
              this.factura.furnizor = this.factura.furnizor;
              this.factura.furnizor_obj = this.factura.furnizor_obj;
            }

            // Defensive: ensure factura is a valid payload, use spread to avoid Form proxy issues
            const facturaPayload = this.factura ? { ...this.factura } : {};
            const payload = {
              factura: facturaPayload,
              produse: produseFiltrate,
              id_proforma: this.id_proforma_selectata || null,
            };
            axios.post('/api/facturare/intrari/adaugaFacturaIntrare', payload)
              .then((response) => {
                this.$Progress.finish();

                // dacă backend-ul a trimis status: "success", considerăm operațiunea reușită
                const data = response && response.data ? response.data : {};
                const msg = data.message || 'Factura de intrare a fost adăugată cu succes.';

                toast.fire({
                  icon: 'success',
                  title: msg,
                  timer: undefined,
                  showConfirmButton: false,
                  showCloseButton: true,
                });

                // notificăm lista să se reîncarce și comutăm pe listă
                if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
                  try {
                    emitter.emit('AfterCreate');
                  } catch (err) {
                    console.error('Eroare în handler-ul AfterCreate:', err);
                  }
                }
                this.$emit('update:afiseazaLista', true);

                // opțional: resetăm doar minim datele locale, fără apeluri suplimentare care pot arunca eroare
                this.facturaProduse = [
                  {
                    pozitie: 1,
                    tip: '1',
                    denumire: '',
                    um: '',
                    cota_tva: 19,
                    cantitate: '',
                    pret: '',
                    valoare: '',
                    valoare_tva: '',
                    total: '',
                    cont_credit: '',
                  }
                ];
              })
              .catch((error) => {
                let mesaj = 'Eroare la salvarea facturii.';
                if (error && error.response && error.response.data) {
                  if (error.response.data.message) {
                    mesaj = error.response.data.message;
                  }
                  if (error.response.data.errors) {
                    const detalii = Object.values(error.response.data.errors)
                      .map(err => `• ${err}`)
                      .join('<br>');
                    mesaj += '<br><br>' + detalii;
                  }
                } else if (error && error.message) {
                  mesaj = error.message;
                }

                toast.fire({
                  icon: 'error',
                  title: mesaj,
                  timer: undefined,
                  showConfirmButton: false,
                  showCloseButton: true,
                });
                console.error('Eroare la salvarea facturii (axios):', error);
                this.$Progress.fail();
              });
        },
        editareFurnizorFormFill(furnizor){
            this.form_modal_furnizori.reset();
            this.form_modal_furnizori.fill(furnizor);
            this.showFormAdaugareFurnizor = true;
            this.editmode = true;
        },
        modalNomenclatorFurnizori(){
            this.editmode = false;
            this.form_modal_furnizori.reset();
            this.incarcaDetaliiFurnizori();
            $('#FurnizorModal').modal('show');
        },
        deschideFormAdaugareFurnizor(searchTerm) {
          // deschidem modalul de furnizori
          this.modalNomenclatorFurnizori();

          // după ce modalul e randat, afișăm direct formularul de adăugare
          this.$nextTick(() => {
            this.showFormAdaugareFurnizor = true;

            // precompletăm denumirea cu textul căutat
            if (this.form_modal_furnizori) {
              this.form_modal_furnizori.f_denumire = searchTerm || '';
            }
          });
        },
        deschideModalFP() {
          this.incarcaProforme();
          $('#ModalProforme').modal('show');
        },
        incarcaProforme() {
          axios.get('/api/facturare/utils/incarcaDateFP')
            .then((response) => {
              this.proforme = Array.isArray(response.data) ? response.data : [];
            })
            .catch((error) => {
              console.error('Eroare la încărcarea proformelor:', error);
              this.proforme = [];
            });
        },
        selecteazaProforma(pf) {
          if (!pf || !pf.id) return;
          // UI loading doar pentru acest rând
          if (this.$set) this.$set(pf, '_loading', true); else pf._loading = true;

          axios.get(`/api/facturare_proforme/utils/detalii/${pf.id}`)
            .then(({ data }) => {
              const { f, date, produse } = data || {};

              // 1) Furnizor (nu schimbăm seria/numărul din formularul de factură)
              if (f && f.id_furnizor) {
                const cli = this.lista_furnizori.find(c => Number(c.id) === Number(f.id_furnizor));
                if (cli) {
                  this.factura.furnizor_obj = cli;
                  this.factura.furnizor = cli.id;
                  this.incarcaSoldFurnizorSelected(cli);
                }
              }

              // 2) Info suplimentare (NU modificăm datele și seria/numărul!)
              if (f && typeof f.informatii_suplimentare === 'string') {
                this.factura.informatii_suplimentare = f.informatii_suplimentare;
              }

              // 3) Produse din proformă -> mapare pe structura formularului de factură
          if (Array.isArray(produse) && produse.length) {
            this.facturaProduse = produse.map((p, idx) => {
              const tipId = p.tip != null ? Number(p.tip) : 1;
              const tipObj = this.tip_produse.find(t => Number(t.id) === tipId) || null;
              // UM poate veni ca id numeric sau ca text (ex: "buc", "ore") sau chiar ca string numeric ("1"). Încercăm toate variantele întâlnite în proforme.
              let umObj = null;
              if (this.unitati_masura && this.unitati_masura.length) {
                const umIdRaw = (p.um_id !== undefined ? p.um_id : (p.id_um !== undefined ? p.id_um : p.um));
                const umTextRaw = (p.um_text || p.unitate_masura || p.um_denumire || (typeof p.um === 'string' ? p.um : ''));
                const umLower = String(umTextRaw || '').trim().toLowerCase();

                // 0) dacă textul este un numeric pur ("1", "2" ...), tratează-l ca id
                const umNumericFromText = (umTextRaw !== undefined && umTextRaw !== null && String(umTextRaw).trim() !== '' && /^\d+$/.test(String(umTextRaw).trim()))
                  ? Number(String(umTextRaw).trim())
                  : null;

                // 1) match după id (din p.um_id / p.id_um / p.um)
                if (umIdRaw !== undefined && umIdRaw !== null && umIdRaw !== '') {
                  umObj = this.unitati_masura.find(u => Number(u.id) === Number(umIdRaw)) || null;
                }

                // 1.1) dacă nu găsim pe id, dar avem numeric în umTextRaw, încearcă-l ca id
                if (!umObj && umNumericFromText !== null) {
                  umObj = this.unitati_masura.find(u => Number(u.id) === umNumericFromText) || null;
                }

                // 2) dacă nu găsim pe id, încercăm pe text
                if (!umObj && umLower) {
                  umObj = this.unitati_masura.find(u => (u.text || '').toLowerCase() === umLower)
                       || this.unitati_masura.find(u => ((u.text || '').split(' (')[0] || '').toLowerCase() === umLower)
                       || null;
                }

                // 3) dacă tot nu găsim, mai încercăm numeric pe p.um dacă e string numeric
                if (!umObj && p.um !== undefined && p.um !== null && p.um !== '' && !isNaN(Number(p.um))) {
                  umObj = this.unitati_masura.find(u => Number(u.id) === Number(p.um)) || null;
                }

                // IMPORTANT: nu mai facem fallback pe primul element, ca să nu setăm eronat 1
                if (!umObj) {
                  console.warn('UM din proformă nu a putut fi mapat:', { umIdRaw, umTextRaw, p });
                }
              }

              const cant = p.cantitate != null ? p.cantitate : '';
              const pret = p.pret_unitar != null ? p.pret_unitar : '';
              const cota = p.cota_tva != null ? p.cota_tva : 19;
              const val  = p.valoare != null ? p.valoare : '';
              const tva  = p.tva != null ? p.tva : '';
              const tot  = p.total != null ? p.total : '';

              return {
                pozitie: idx + 1,
                tip: String(tipId),
                tip_obj: tipObj,
                denumire: p.denumire || '',
                denumire_obj: p.denumire ? { id: null, text: p.denumire } : null,
                um: umObj ? umObj.id : '',
                cota_tva: Number(cota),
                cantitate: cant,
                pret: pret,
                valoare: val,
                valoare_tva: tva,
                total: tot,
                cont_credit: p.cont_credit || ''
              };
            });

            // recalculări de siguranță (dacă lipsesc câmpuri)
            this.facturaProduse.forEach((prod, i) => this.updateCalculations(this.facturaProduse[i]));
          }

              // Setează id_proforma_selectata înainte de închiderea modalului
              this.id_proforma_selectata = pf.id;
              // 4) Închide modalul și anunță utilizatorul
              $('#ModalProforme').modal('hide');
              toast.fire({ icon: 'success', title: 'Proforma a fost preluată în formular.' });
            })
            .catch((err) => {
              console.error('Eroare la preluarea proformei:', err);
              toast.fire({ icon: 'error', title: 'Eroare la preluarea proformei.' });
            })
            .finally(() => {
              if (this.$set) this.$set(pf, '_loading', false); else pf._loading = false;
            });
        },
        async creeazaFacturaInstant(pf) {
          if (!pf || !pf.id) return;
          if (this.$set) this.$set(pf, '_creating', true); else pf._creating = true;

          try {
            const confirm = await Swal.fire({
              title: 'Creezi factura direct?',
              html: `
                <p>Această acțiune va genera factura imediat, fără editare.</p>
                <p style="color: red; font-weight: bold;">Aceasta va folosi ultima plajă de serii folosită!</p>
              `,
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Da, creează',
              cancelButtonText: 'Anulează'
            });

            if (!confirm.isConfirmed) return;

            const response = await axios.post('/api/facturare/creeazaDinProforma', { id_proforma: pf.id });
            toast.fire({
              icon: 'success',
              title: `Factura #${response.data.nr_doc} a fost creată cu succes!`
            });

            // Scoatem proforma din listă, pentru că acum e facturată
            this.proforme = this.proforme.filter(p => p.id !== pf.id);
            // Notifică lista de facturi să se reîncarce și comută pe listă
            if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
              try {
                emitter.emit('AfterCreate');
              } catch (err) {
                console.error('Eroare în handler-ul AfterCreate:', err);
              }
            }
            this.$emit('update:afiseazaLista', true);

          } catch (error) {
            console.error('Eroare la crearea facturii instant:', error);
            toast.fire({
              icon: 'error',
              title: 'Eroare la crearea facturii instant.'
            });
          } finally {
            if (this.$set) this.$set(pf, '_creating', false); else pf._creating = false;
          }
        },
        incarcaUltimaFactura() {
          axios.get('/api/facturare/utils/iaSerieNR')
            .then((response) => {
              const { serie_id, serie_text, numar } = response.data;

              if (numar) this.factura.nr_document = numar + 1;

              const serieIdNum = Number(serie_id);

              // Folosim direct referința din lista existentă
              const obiectSerie = this.serii_facturi.find(s => Number(s.id) === serieIdNum);

              if (obiectSerie) {
                this.factura.serie_document_obj = obiectSerie;
                this.factura.serie_document = obiectSerie.id;
              } else {
                // Adăugăm doar dacă nu există deja
                const newOption = { id: serieIdNum, text: serie_text };
                this.serii_facturi.push(newOption);
                this.factura.serie_document_obj = newOption;
                this.factura.serie_document = serieIdNum;
              }
            })
            .catch(() => {
              this.$toast.error('Eroare la încărcarea ultimei facturi');
            });
        }
        
    },
    mounted() {
      this.incarcaUltimaFactura();
    },
    
    computed: {
        modelAfiseazaLista: {
            get() {
                return this.afiseazaLista;
            },
            set(value) {
                this.$emit('update:afiseazaLista', value);
            }
        }
    },
    watch: {
      facturaProduse: {
        handler(newVal, oldVal) {
          // Watch pentru fiecare produs, daca totalul se schimba manual, actualizeaza pret/valoare/valoare_tva
          newVal.forEach((produs, index) => {
            if (
              oldVal &&
              oldVal[index] &&
              produs.total !== oldVal[index].total
              && produs.total !== ""
            ) {
              this.updateFromTotal(index);
            }
          });
        },
        deep: true
      },
    },
    created(){
        emitter.on('searching',() => {//search
            let query = this.$parent.search;
            axios.get('/api/utile/cautareDosare?cD=' + query)
            .then((data)=>{
                this.dosare =data.data
            })
            .catch(()=>{
                console.log('eroare la cautare');
            })
        })
        emitter.on('AfterCreate',() => { 

        });
        this.incarcaFurnizori();
        this.incarcaSerii();
        this.incarcaUnitatiMasura();
        this.incarcaTipProduse();
        this.incarcaProduseSelect2();
        this.incarcaValute();
    },
    
    }
    </script>
    
<style lang="scss" scoped>
      table {
        table-layout: fixed;
        width: 100%;
      }
      .icon-mare {
          font-size: 24px
      }
      .modal {
          z-index: 9003
      }
      #tabel_furnizori {
          border-collapse: collapse;
          border-spacing: 0;
      }
      #tabel_furnizori th,
      #tabel_furnizori td {
          padding: 2px 2px;
          border: 1px solid #ccc;
          font-size: 13px;
          vertical-align: middle;
      }

  .select2-fix .select2-container {
    width: 280px !important;
    min-width: 280px !important;
    max-width: 280px !important;
  }

  .select2-fix .select2-selection {
    height: 38px !important;
    display: flex !important;
    align-items: center !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    border-radius: 4px;
  }

  .select2-fix .select2-selection__rendered {
    display: block !important;
    width: 100% !important;
    padding-right: 10px;
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }

  .select2-fix {
    min-width: 0 !important;
    flex-shrink: 1 !important;
    overflow: hidden !important;
  }

  .select2-fix {
    width: 100% !important;
    display: block;
  }

  .multiselect {
    min-height: 38px;
    padding: 0;
    font-size: 0.85rem;
  }

  .multiselect__single {
    padding: 4px 8px;
  }

  .furnizor-multiselect .multiselect__single {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.95rem;
  }

  .multiselect-custom {
    position: relative;
  }

  .multiselect-custom .multiselect__content-wrapper {
    z-index: 999999 !important;
    position: absolute !important;
    top: 100% !important;
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
    background-color: white;
  }

  .row, .table-responsive {
    overflow: visible !important;
    position: relative;
  }

  .multiselect__content-wrapper {
    z-index: 999999 !important;
    position: absolute !important;
    top: 100% !important;
    left: 0;
    right: 0;
    max-height: 300px;
    overflow-y: auto;
    background-color: white;
  }

  .multiselect__content {
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    z-index: 9999;
    background: white;
    border: 1px solid #e0e0e0;
  }

  .multiselect__element {
    position: relative;
    z-index: 2;
  }

  .tip-produse-multiselect {
    max-width: 100%;
    font-size: 0.9rem;
    white-space: nowrap;
    //overflow: hidden;
    text-overflow: ellipsis;
  }

/* Asigură-te că dropdown-ul poate depăși containerul */
.multiselect-denumire {
  overflow: visible !important;
  position: relative !important;
  z-index: 999;
}

/* Forțează meniul dropdown să fie vizibil și să aibă dimensiunea completă */
.multiselect-denumire .multiselect__content-wrapper {
  position: absolute !important;
  z-index: 9999 !important;
  width: max-content;
  min-width: 100%;
  background: white;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  left: 0;
}

/* Asigură-te că wrapper-ele nu ascund dropdownul */
.row,
.col-auto,
.table-responsive,
.template {
  overflow: visible !important;
}


  /* ----- vue-multiselect typing color / contrast fixes ----- */
  :deep(.multiselect__input),
  :deep(.multiselect__single),
  :deep(.multiselect__placeholder),
  :deep(.multiselect__tags) {
    color: var(--bs-body-color) !important;
    background-color: var(--bs-body-bg) !important;
  }

  /* Actual input inside tags (when typing) */
  :deep(.multiselect__tags input.multiselect__input) {
    color: var(--bs-body-color) !important;
    caret-color: var(--bs-primary, #3e97ff) !important;
  }

  /* Dropdown panel + options */
  :deep(.multiselect__content-wrapper),
  :deep(.multiselect__content) {
    background-color: var(--bs-body-bg) !important;
    color: var(--bs-body-color) !important;
    border: 1px solid var(--bs-border-color, #e4e6ef) !important;
  }
  :deep(.multiselect__element),
  :deep(.multiselect__option) {
    color: var(--bs-body-color) !important;
  }
  :deep(.multiselect__option--highlight),
  :deep(.multiselect__option--selected) {
    background-color: var(--bs-primary, #3e97ff) !important;
    color: #fff !important;
  }

  /* Dark theme fine-tune, if needed */
  [data-bs-theme="dark"] :deep(.multiselect__tags),
  [data-bs-theme="dark"] :deep(.multiselect__input),
  [data-bs-theme="dark"] :deep(.multiselect__single),
  [data-bs-theme="dark"] :deep(.multiselect__placeholder) {
    background-color: #1e1e2d !important;
    color: #e1e3ea !important;
  }
  [data-bs-theme="dark"] :deep(.multiselect__content-wrapper),
  [data-bs-theme="dark"] :deep(.multiselect__content) {
    background-color: #1e1e2d !important;
    border-color: #2b2b40 !important;
  }

/* TIP: permite shrink + ellipsis în label */
.tip-col { min-width: 0 !important; }
:deep(.tip-produse-multiselect .multiselect__single) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

/* Denumire: ellipsis pentru ambele multiselecturi */
.denumire-col { min-width: 0 !important; }
:deep(.multiselect-denumire .multiselect__single),
:deep(.multiselect-custom .multiselect__single) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}


/* === Modal Proforme: standard size + safe wrapping (no overflow) === */
#ModalProforme .modal-dialog {
  max-width: 900px !important; /* Bootstrap modal-lg approx */
  margin: 1.25rem auto !important;
}
#ModalProforme .modal-content { overflow: hidden; }
#ModalProforme .modal-body { overflow: hidden; }
#ModalProforme .table-responsive { overflow-x: auto; }
#ModalProforme .table { table-layout: fixed; width: 100%; }
#ModalProforme .table th,
#ModalProforme .table td {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  vertical-align: middle;
}
/* Butoanele din coloana Acțiuni rămân în interior; pot face wrap când e nevoie */
#ModalProforme td.actions { white-space: nowrap; }
#ModalProforme td.actions.d-flex { flex-wrap: wrap; }
#ModalProforme td.actions .btn { white-space: nowrap; }
</style>

<style scoped>


</style>

